import Vue from "vue";
import App from "./App.vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import router from "./router";
import axios from "axios";
import * as auth from "@/utils/auth.js";
import VueCookies from "vue-cookies";
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueCookies);
// Vue.$cookies.config("1d");
Vue.prototype.$axios = axios;

router.beforeEach(function (to, from, next) {
  // 路由守卫 
  if (to.meta.title) document.title = to.meta.title;
  else document.title = "后台管理系统";
  if (to.meta.needLogin) {
    if (auth.isLoginExpired()) {
      ElementUI.Message({
        message: "登录已超时，请重新登录",
        type: "warning",
      });
      next({
        path: "/Login",
      });
    } else if (auth.getAdminInfo()) {
      // 判断是否登录
      next();
    } else {
      ElementUI.Message({
        message: "请先登录~",
        type: "warning",
      });
      next({
        path: "/Login",
      });
    }
  } else {
    next();
  }
});
new Vue({
  render: (h) => h(App),
  router,
}).$mount("#app");
